export default {
  scrollListener(divId, topThreshold, bottomThreshold) {
    topThreshold = topThreshold || 100
    bottomThreshold = bottomThreshold || 50
    var scrollTop     = $(window).scrollTop(),
        elementOffset = $(`#${divId}`).offset().top,
        height = $(`#${divId}`).height(),
        distance      = (elementOffset - scrollTop);

    if (distance < topThreshold && height + distance > bottomThreshold ) {
      return true
    } else {
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/AttachProductComponents/productScrollHelper.js